<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/studyabroad' }"
        >升学规划</el-breadcrumb-item
      >
      <el-breadcrumb-item>特殊招生</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="top">
          <div class="title">特殊类型招生</div>
          <div class="covering">
            特殊招生并没有严格的定义，一般是指普通高校招生中的一些特殊类型或特殊政策。大多数特殊类型招生仍要求考生参加全国统一高考并按规定程序录取；个别特殊类型招生（如保送生、体育单招等）不需要参加全国统一高考，采取单独的选拔录取方式。入学后，特殊类型招收的考生待遇一般与普通类考生相同
          </div>
        </div>
        <div class="btn">
          <div
            class="journalism"
            @click="go(it.url)"
            v-for="(it, ind) in list"
            :key="ind"
          >
            <div class="left"><img :src="it.pic" alt="" /></div>
            <div class="right">
              <div :id="it.title" class="journalism_top">{{ it.title }}</div>
              <div class="journalism_centent">
                {{ it.summary }}
              </div>
              <div class="journalism_next"><a>了解更多</a></div>
            </div>
          </div>
          <div class="anchor">
            <div v-for="(it, ind) in list" :key="ind">
              <a :href="`#${it.title}`">{{ it.title }}</a>
            </div>
            <div>
              <a href="#">回到顶部↑</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetStudentslist } from "@/api/home";
export default {
  name: "XSpecialentrance",

  data() {
    return {
      list: "",
    };
  },

  async mounted() {
    const res = await GetStudentslist();
    this.list = res.data||res.result;
  },

  methods: {
    go(routeUrl) {
      window.open(routeUrl, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/global.less";
.box {
  margin-top: 10px;
  min-width: 1050px;
  .content {
    .top {
      width: 98%;
      height: 135px;
      border-radius: 3px 3px 3px 3px;
      background-color: #fff;
      padding: 17px 0 0 33px;
      margin-bottom: 32px;
      .title {
        padding-bottom: 14px;
        font-size: 22px;
        color: #333;
        font-weight: bold;
      }
      .covering {
        width: 96%;
        font-size: 14px;
        line-height: 30px;
        color: #666;
      }
    }
    .btn {
      position: relative;
      width: 98%;
      height: 100%;
      border-radius: 3px 3px 3px 3px;
      background-color: #fff;
      padding: 29px 0 0 47px;
      .journalism {
        display: flex;
        margin-bottom: 46px;
        cursor: pointer;
        .left {
          width: 294px;
          height: 162px;
          margin-right: 35px;
          img {
            height: 100%;
          }
        }
        .right {
          .journalism_top {
            font-size: 22px;
            color: #333;
            font-weight: bold;
            margin-bottom: 12px;
          }
          .journalism_centent {
            width: 60%;
            font-size: 14px;
            color: #666;
            line-height: 20px;
            margin-bottom: 37px;
          }
          .journalism_next a {
            text-decoration: none;
            color: @blues;
          }
        }
      }
      .anchor {
        position: fixed;
        right: 40px;
        bottom: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 178px;
        height: 600px;
        background-image: url("./images/Group2.png");
        a {
          font-size: 14px;
          color: #333;
          line-height: 40px;
          text-decoration: none;
        }
      }
    }
  }
}
</style>